module.exports = __webpack_public_path__ + "static/scale-model-of-grave-of-leonard-nimoy-in-inglewood-california-4b726b5a9d1ee41cc65c00104bcca9ef.png";